module.exports = __webpack_public_path__ + "img/797b01f.jpg";